import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/web/getmoga/closebutton.png'
import _imports_1 from '../../assets/ggm_icon.png'
import _imports_2 from '../../assets/app/wallet/to.png'


const _withScopeId = n => (_pushScopeId("data-v-03d52fa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column align-items-center justify-content-center" }
const _hoisted_2 = {
  class: "p-1 items-center text-center text-white text-xl JungleAdventurer flex align-items-center",
  style: {"width":"100%","color":"#443862","border-bottom":"1px solid #9185a1","background":"rgb(44,38,62)"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-1 text-xl",
  style: {"color":"rgb(156,131,199)"}
}, "Send", -1))
const _hoisted_4 = { class: "space-y-8 p-4" }
const _hoisted_5 = { class: "flex space-x-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-white font-semibold w-16" }, "Assets")
], -1))
const _hoisted_7 = { class: "flex items-center space-x-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-8 h-8"
}, null, -1))
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white font-semibold" }, "GGM", -1))
const _hoisted_11 = { class: "text-xs mr-1" }
const _hoisted_12 = { class: "flex space-x-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-white font-semibold w-16" }, "Amount")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "GGM", -1))
const _hoisted_15 = { class: "flex flex-col space-y-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "55",
    src: _imports_2
  })
], -1))
const _hoisted_17 = { class: "flex space-x-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-white w-20 font-semibold" }, "Account ID")
], -1))
const _hoisted_19 = { class: "flex space-x-8 items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white w-16 font-semibold" }, "Note", -1))
const _hoisted_21 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_caret_down_filled = _resolveComponent("caret-down-filled")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    width: "400px",
    destroyOnClose: "",
    closable: false,
    visible: _ctx.visible,
    "header-style": {display:'none'},
    footer: null,
    style: {"padding-bottom":"0","background":"#5B4973","overflow":"hidden","border-radius":"12px","box-shadow":"rgba(0, 0, 0, 0.3) 0px 8px 8px, rgb(91, 73, 115) 0px 4px"},
    "dialog-style": "background: #5B4973",
    "body-style": "background: #5B4973;padding:0;"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("img", {
            class: "cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.modalclose && _ctx.modalclose(...args))),
            width: "35",
            src: _imports_0
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_a_card, {
            loading: _ctx.loading,
            class: "ggm-card w-full"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, "Balance: " + _toDisplayString(_ctx.balanceFormat(_ctx.balanceInfo?.account?.assets[1]?.amount)), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_a_input_number, {
            style: {"width":"80%","background":"#1f1927"},
            class: "a-input",
            value: _ctx.amountValue,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amountValue) = $event)),
            controls: false,
            onFocus: _ctx.focus
          }, {
            addonAfter: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["value", "onFocus"]),
          _createElementVNode("div", {
            class: "max-button cursor-pointer rounded-xl px-2 py-1",
            style: {"background-color":"#01BD35","box-shadow":"0px 4px 4px rgba(0,0,0,.3),0 2px rgba(4,184,53,1)"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMaxClick && _ctx.handleMaxClick(...args)))
          }, " MAX ")
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_a_select, {
              style: {},
              value: _ctx.accountIdValue,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accountIdValue) = $event)),
              "show-search": "",
              class: "w-60 a-select 1f1927",
              allowClear: "",
              options: _ctx.data1,
              filterOption: false,
              onSearch: _ctx.myhandleSearch,
              onChange: _ctx.myhandleChange,
              onFocus: _ctx.focus
            }, {
              suffixIcon: _withCtx(() => [
                _createVNode(_component_caret_down_filled)
              ]),
              _: 1
            }, 8, ["value", "options", "onSearch", "onChange", "onFocus"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_a_input, {
              class: "a-input bg-[#1f1927]",
              style: {"width":"242px"},
              value: _ctx.remarkValue,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.remarkValue) = $event)),
              placeholder: "Option"
            }, null, 8, ["value"])
          ])
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_a_alert, {
              key: 0,
              message: _ctx.isErrorMessage,
              type: "error"
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", {
            style: {"background-color":"#01BD35","box-shadow":"0px 8px 8px rgba(0,0,0,.3),0 4px rgba(4,184,53,1)"},
            class: "text-xl next-button cursor-pointer JungleAdventurer p-2 w-96 text-center rounded-2xl",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSendClick && _ctx.handleSendClick(...args)))
          }, "Send")
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}